import { AnyAction } from 'redux';
import { ProductType } from '@/types';
import { fetchFirstProductType } from '@/utils/http/fetchFirstProductType';
import { Thunk } from '@/redux/types';
import { setProductTypeAction } from './setProductTypeAction';

export const fetchFirstProductTypeAction: Thunk<Promise<ProductType>, AnyAction> = (dispatch) => {
  return fetchFirstProductType().then((productType) => dispatch(setProductTypeAction(productType)));
};
